import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default function setBannersLinha() {
  const sections = document.querySelectorAll('[data-banner-linha]');

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');

    new Swiper(carousel, {
      modules: [Pagination],
      slidesPerView: 2.2,
      spaceBetween: 8,
      watchOverflow: true,
      speed: 1000,
      pagination: {
        el: pagination,
        type: 'progressbar',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
      },
    });
  });
}
